// import React, { useState, useEffect } from 'react';
// import { supabase } from '../supabaseClient';
// import { 
//   Menu, 
//   X, 
//   ChevronDown, 
//   Phone, 
//   MapPin, 
//   Clock, 
//   Twitter, 
//   Instagram, 
//   Youtube, 
//   Linkedin 
// } from 'lucide-react';
// import { NRLogo } from './NRLogo';
// import { UserAuth } from './AuthContext';
// import LogoutButton from './LogOut';
// import { useNavigate, useLocation } from 'react-router-dom';

// export const Header = () => {
//   const location = useLocation(); 
//   const { session } = UserAuth();
//   const navigate = useNavigate();

//   const [user, setUser] = useState(null);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [openMobileDropdown, setOpenMobileDropdown] = useState(null);

//   useEffect(() => {
//     const checkUser = async () => {
//       const currentSession = await session;
//       setUser(currentSession?.user || null);
//     };
//     checkUser();

//     const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
//       if (event === 'SIGNED_OUT') {
//         setUser(null);
//         navigate('/login');
//       } else if (event === 'SIGNED_IN') {
//         setUser(session?.user);
//       }
//     });

//     return () => {
//       listener.subscription.unsubscribe();
//     };
//   }, [session, navigate]);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 40);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = [
//     { name: 'الرئيسية', href: '#hero' },
//     {
//       name: 'خدماتنا',
//       href: '#services',
// //      dropdown: [
// //   { name: 'الاستشارات القانونية', path: '/legal' },
// //   { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
// //   { name: 'الترافع والتقاضي', path: '/litigation' },
// //   { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
// //   { name: 'تصفية التركات وفض النزاعات الإرثية', path: '/estate-liquidation' },
// //   { name: 'الأوقاف والوصايا', path: '/waqf-will' },
// //   { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
// //   { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
// //   { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
// //   { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' }
// // ],

// dropdowns: {
//   // القائمة المنسدلة الأولى: خدمات الشركات والأعمال والاستثمار
//   corporateAndInvestment: [
//     { name: 'الاستشارات القانونية', path: '/legal' },
//     { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
//     { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
//     { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
//     { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
//     { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
//     { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
//     { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
//     { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
//     { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
//   ],

//   // القائمة المنسدلة الثانية: الخدمات القضائية، التصفية والتوثيق
//   litigationAndJudicial: [
//     { name: 'الترافع والتقاضي', path: '/litigation' },
//     { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
//     { name: 'الحراسة القضائية', path: '/judicial-custody' },
//     { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
//     { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
//     { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
//     { name: 'الأوقاف والوصايا', path: '/waqf-will' },
//     { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
//     { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
//     { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
//   ]
// },
//     },
//     { name: 'عن الشركة', href: '#about' },
//     { name: 'فريق العمل', href: '#attorneys' },
//     { name: 'شركاؤنا', href: '#partners', path: '/partners' },
//     { name: 'اتصل بنا', href: '#contact' },
//   ];

//   const scrollToSection = (sectionId) => {
//     const section = document.querySelector(sectionId);
//     if (section) {
//       // حساب الارتفاع الديناميكي للهيدر لتجنب تغطية عناوين الأقسام
//       const headerHeight = document.querySelector('header').offsetHeight;
//       const sectionTop = section.offsetTop - headerHeight;
//       window.scrollTo({ top: sectionTop, behavior: 'smooth' });
//       setIsMenuOpen(false);
//     }
//   };

//   return (
//     <header 
//       className="fixed top-0 right-0 left-0 z-50 w-full"
//       dir="rtl"
//     >
//       {/* 1. Dynamic TopBar: يختفي بسلاسة تامة عند النزول لأسفل */}
//       <div 
//         className={`w-full bg-slate-900 text-slate-300 border-b border-amber-500/10 transition-all duration-300 hidden md:block overflow-hidden ${
//           isScrolled ? 'max-h-0 opacity-0 py-0 border-none' : 'max-h-12 py-2.5 opacity-100'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
//           {/* المواعيد ورقم الاتصال */}
//           <div className="flex items-center gap-6">
//             <div className="flex items-center gap-2 text-slate-400 text-xs lg:text-sm">
//               <Clock className="h-3.5 w-3.5 text-amber-500/80" />
//               <span>الأحد - الخميس | 8:00 ص - 5:00 م</span>
//             </div>
//             <div className="flex items-center gap-2 border-r border-slate-700/60 pr-6 text-xs lg:text-sm">
//               <Phone className="h-3.5 w-3.5 text-amber-500/80" />
//               <a href="tel:+966595014100" className="hover:text-amber-400 transition-colors duration-200 font-medium tracking-wide" dir="ltr">
//                 +966 59 501 4100
//               </a>
//             </div>
//           </div>

//           {/* العنوان الجغرافي في المنتصف */}
//           <div className="flex items-center gap-2 text-slate-400 text-xs lg:text-sm">
//             <MapPin className="h-3.5 w-3.5 text-amber-500/80" />
//             <span>جدة - المملكة العربية السعودية</span>
//           </div>

//           {/* أيقونات التواصل الاجتماعي */}
//           <div className="flex items-center gap-4">
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Twitter className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Instagram className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Youtube className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Linkedin className="h-4 w-4" /></a>
//           </div>
//         </div>
//       </div>

//       {/* 2. Main Navigation Bar: يتغير شكله وخلفيته بالتزامن مع الحركة */}
//       <div 
//         className={`w-full border-b transition-all duration-500 ${
//           isScrolled 
//             ? 'bg-white/95 backdrop-blur-sm shadow-md border-amber-500/20 py-2.5' 
//             : 'bg-transparent border-transparent py-5'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between gap-4">
            
//             {/* الهوية البصرية والشعار */}
//             <div className="flex items-center gap-3 md:gap-4 shrink-0 z-50">
//               <NRLogo className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 transition-transform duration-300" color={isScrolled ? '#0f172a' : '#FFFFFF'} />
//               <div className="flex flex-col">
//                 <span className={`font-bold transition-colors duration-300 leading-tight text-xs sm:text-sm md:text-base lg:text-lg ${
//                   isScrolled ? 'text-slate-900' : 'text-white'
//                 }`}>
//                   شركة ناصر الراجحي ورامي المطيري
//                 </span>
//                 <span className={`font-medium text-[10px] sm:text-xs tracking-wide transition-colors duration-300 mt-0.5 ${
//                   isScrolled ? 'text-amber-600' : 'text-amber-400'
//                 }`}>
//                   للمحاماة والاستشارات القانونية
//                 </span>
//               </div>
//             </div>

//             {/* روابط التصفح للشاشات الكبيرة */}
//             <nav className="hidden lg:flex items-center gap-6 xl:gap-8 whitespace-nowrap">
//               {navItems.map((item) => (
//                 <div key={item.name} className="relative group py-2">
//                   <a 
//                     href={item.path ? item.path : (location.pathname === '/' ? item.href : `/${item.href}`)}
//                     onClick={(e) => {
//                       if (item.href && item.href.startsWith('#') && location.pathname === '/') {
//                         e.preventDefault();
//                         scrollToSection(item.href);
//                       }
//                     }}
//                     className={`text-sm xl:text-base font-medium transition-colors duration-300 flex items-center gap-1 hover:text-amber-600 ${
//                       isScrolled ? 'text-slate-700' : 'text-white/90'
//                     }`}
//                   >
//                     {item.name}
//                     {item.dropdown && <ChevronDown className="w-3.5 h-3.5 opacity-70 group-hover:rotate-180 transition-transform duration-300" />}
//                   </a>

//                   {/* القائمة المنسدلة للخدمات */}
//                   {item.dropdown && (
//                     <div className="absolute right-0 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 z-50">
//                       <div className="bg-slate-900 border border-slate-800 shadow-xl rounded-xl min-w-[220px] py-2 overflow-hidden">
//                         {item.dropdown.map((subItem) => (
//                           <a
//                             key={subItem.name}
//                             href={subItem.path}
//                             className="block px-5 py-3 text-sm text-slate-300 hover:text-white hover:bg-slate-800/80 transition-colors duration-200 border-r-2 border-transparent hover:border-amber-500"
//                           >
//                             {subItem.name}
//                           </a>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ))}

//               {/* لوحة التحكم للمسؤولين */}
//               {user && (
//                 <div className="flex items-center gap-4 border-r border-slate-300/50 pr-4 mr-2">
//                   <a href="/post" className={`text-sm font-medium hover:text-amber-600 transition ${isScrolled ? 'text-slate-700' : 'text-white'}`}>إنشاء منشور</a>
//                   <a href="/emails" className={`text-sm font-medium hover:text-amber-600 transition ${isScrolled ? 'text-slate-700' : 'text-white'}`}>البريد الإلكتروني</a>
//                   <LogoutButton />
//                 </div>
//               )}
//             </nav>

//             {/* زر القائمة المنسدلة للهواتف */}
//             <button 
//               className="lg:hidden p-2 rounded-lg transition-colors duration-200 relative z-50 hover:bg-slate-100/10 focus:outline-none"
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               aria-label="Toggle Navigation"
//             >
//               {isMenuOpen ? 
//                 <X className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} /> : 
//                 <Menu className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} />}
//             </button>
//           </div>

//           {/* القائمة الجانبية للهواتف والأجهزة اللوحية */}
//           {isMenuOpen && (
//             <div className="lg:hidden fixed inset-x-4 top-20 bg-slate-900 border border-slate-800 rounded-2xl shadow-2xl p-4 z-40 max-h-[calc(100vh-120px)] overflow-y-auto animate-in fade-in zoom-in-95 duration-200">
//               <nav className="flex flex-col space-y-1">
//                 {navItems.map((item) => (
//                   <div key={item.name} className="border-b border-slate-800/60 last:border-0 pb-1 last:pb-0">
//                     <button
//                       onClick={(e) => {
//                         if (item.dropdown) {
//                           setOpenMobileDropdown(openMobileDropdown === item.name ? null : item.name);
//                         } else if (item.href?.startsWith('#') && location.pathname === '/') {
//                           e.preventDefault();
//                           scrollToSection(item.href);
//                         } else {
//                           window.location.href = item.path || `/${item.href}`;
//                         }
//                       }}
//                       className="w-full text-right text-slate-200 hover:text-white text-base font-medium flex items-center justify-between py-3 px-4 hover:bg-slate-800 rounded-xl transition-colors duration-200"
//                     >
//                       <span>{item.name}</span>
//                       {item.dropdown && (
//                         <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${openMobileDropdown === item.name ? 'rotate-180 text-amber-500' : 'text-slate-400'}`} />
//                       )}
//                     </button>

//                     {item.dropdown && openMobileDropdown === item.name && (
//                       <div className="mr-4 my-1 flex flex-col border-r-2 border-amber-500/30 pr-2 bg-slate-950/40 rounded-l-lg py-1">
//                         {item.dropdown.map((subItem) => (
//                           <a key={subItem.name} href={subItem.path} className="text-sm text-slate-400 hover:text-white py-2.5 px-4 rounded-lg transition-colors duration-150">
//                             {subItem.name}
//                           </a>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 ))}

//                 {user && (
//                   <div className="pt-4 mt-2 border-t border-slate-800 space-y-1">
//                     <a href="/post" className="text-slate-200 text-base font-medium block py-3 px-4 hover:bg-slate-800 rounded-xl transition">إنشاء منشور</a>
//                     <a href="/emails" className="text-slate-200 text-base font-medium block py-3 px-4 hover:bg-slate-800 rounded-xl transition">البريد الإلكتروني</a>
//                     <div className="pt-2 px-4"><LogoutButton /></div>
//                   </div>
//                 )}
//               </nav>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// };



// import React, { useState, useEffect } from 'react';
// import { supabase } from '../supabaseClient';
// import { 
//   Menu, 
//   X, 
//   ChevronDown, 
//   Phone, 
//   MapPin, 
//   Clock, 
//   Twitter, 
//   Instagram, 
//   Youtube, 
//   Linkedin 
// } from 'lucide-react';
// import { NRLogo } from './NRLogo';
// import { UserAuth } from './AuthContext';
// import LogoutButton from './LogOut';
// import { useNavigate, useLocation } from 'react-router-dom';

// export const Header = () => {
//   const location = useLocation(); 
//   const { session } = UserAuth();
//   const navigate = useNavigate();

//   const [user, setUser] = useState(null);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
//   const [openMobileSubSection, setOpenMobileSubSection] = useState(null);

//   useEffect(() => {
//     const checkUser = async () => {
//       const currentSession = await session;
//       setUser(currentSession?.user || null);
//     };
//     checkUser();

//     const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
//       if (event === 'SIGNED_OUT') {
//         setUser(null);
//         navigate('/login');
//       } else if (event === 'SIGNED_IN') {
//         setUser(session?.user);
//       }
//     });

//     return () => {
//       listener.subscription.unsubscribe();
//     };
//   }, [session, navigate]);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 40);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = [
//     { name: 'الرئيسية', href: '#hero' },
//     {
//       name: 'خدماتنا',
//       href: '#services',
//       dropdowns: {
//         corporateAndInvestment: {
//           title: 'قطاع الشركات والأعمال',
//           links: [
//             { name: 'الاستشارات القانونية', path: '/legal' },
//             { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
//             { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
//             { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
//             { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
//             { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
//             { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
//             { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
//             { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
//             { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
//           ]
//         },
//         litigationAndJudicial: {
//           title: 'الخدمات القضائية والوقائية',
//           links: [
//             { name: 'الترافع والتقاضي', path: '/litigation' },
//             { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
//             { name: 'الحراسة القضائية', path: '/judicial-custody' },
//             { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
//             { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
//             { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
//             { name: 'الأوقاف والوصايا', path: '/waqf-will' },
//             { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
//             { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
//             { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
//           ]
//         }
//       }
//     },
//     { name: 'عن الشركة', href: '#about' },
//     { name: 'فريق العمل', href: '#attorneys' },
//     { name: 'شركاؤنا', href: '#partners', path: '/partners' },
//     { name: 'اتصل بنا', href: '#contact' },
//   ];

//   const scrollToSection = (sectionId) => {
//     const section = document.querySelector(sectionId);
//     if (section) {
//       const headerHeight = document.querySelector('header').offsetHeight;
//       const sectionTop = section.offsetTop - headerHeight;
//       window.scrollTo({ top: sectionTop, behavior: 'smooth' });
//       setIsMenuOpen(false);
//     }
//   };

//   return (
//     <header className="fixed top-0 right-0 left-0 z-50 w-full" dir="rtl">
//       {/* 1. Dynamic TopBar */}
//       <div 
//         className={`w-full bg-slate-900 text-slate-300 border-b border-amber-500/10 transition-all duration-300 hidden md:block overflow-hidden ${
//           isScrolled ? 'max-h-0 opacity-0 py-0 border-none' : 'max-h-12 py-2.5 opacity-100'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
//           <div className="flex items-center gap-6">
//             <div className="flex items-center gap-2 text-slate-400 text-xs lg:text-sm">
//               <Clock className="h-3.5 w-3.5 text-amber-500/80" />
//               <span>الأحد - الخميس | 8:00 ص - 5:00 م</span>
//             </div>
//             <div className="flex items-center gap-2 border-r border-slate-700/60 pr-6 text-xs lg:text-sm">
//               <Phone className="h-3.5 w-3.5 text-amber-500/80" />
//               <a href="tel:+966595014100" className="hover:text-amber-400 transition-colors duration-200 font-medium tracking-wide" dir="ltr">
//                 +966 59 501 4100
//               </a>
//             </div>
//           </div>

//           <div className="flex items-center gap-2 text-slate-400 text-xs lg:text-sm">
//             <MapPin className="h-3.5 w-3.5 text-amber-500/80" />
//             <span>جدة - المملكة العربية السعودية</span>
//           </div>

//           <div className="flex items-center gap-4">
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Twitter className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Instagram className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Youtube className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Linkedin className="h-4 w-4" /></a>
//           </div>
//         </div>
//       </div>

//       {/* 2. Main Navigation Bar */}
//       <div 
//         className={`w-full border-b transition-all duration-500 ${
//           isScrolled 
//             ? 'bg-white/95 backdrop-blur-sm shadow-md border-amber-500/20 py-2.5' 
//             : 'bg-transparent border-transparent py-5'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between gap-4">
            
//             <div className="flex items-center gap-3 md:gap-4 shrink-0 z-50">
//               <NRLogo className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 transition-transform duration-300" color={isScrolled ? '#0f172a' : '#FFFFFF'} />
//               <div className="flex flex-col">
//                 <span className={`font-bold transition-colors duration-300 leading-tight text-xs sm:text-sm md:text-base lg:text-lg ${
//                   isScrolled ? 'text-slate-900' : 'text-white'
//                 }`}>
//                   شركة ناصر الراجحي ورامي المطيري
//                 </span>
//                 <span className={`font-medium text-[10px] sm:text-xs tracking-wide transition-colors duration-300 mt-0.5 ${
//                   isScrolled ? 'text-amber-600' : 'text-amber-400'
//                 }`}>
//                   للمحاماة والاستشارات القانونية
//                 </span>
//               </div>
//             </div>

//             {/* روابط التصفح للشاشات الكبيرة */}
//             <nav className="hidden lg:flex items-center gap-6 xl:gap-8 whitespace-nowrap">
//               {navItems.map((item) => (
//                 <div key={item.name} className="relative group py-2">
//                   <a 
//                     href={item.path ? item.path : (location.pathname === '/' ? item.href : `/${item.href}`)}
//                     onClick={(e) => {
//                       if (item.href && item.href.startsWith('#') && location.pathname === '/') {
//                         e.preventDefault();
//                         scrollToSection(item.href);
//                       }
//                     }}
//                     className={`text-sm xl:text-base font-medium transition-colors duration-300 flex items-center gap-1 hover:text-amber-600 ${
//                       isScrolled ? 'text-slate-700' : 'text-white/90'
//                     }`}
//                   >
//                     {item.name}
//                     {item.dropdowns && <ChevronDown className="w-3.5 h-3.5 opacity-70 group-hover:rotate-180 transition-transform duration-300" />}
//                   </a>

//                   {/* رندرة القائمتين المتداخلتين الفخمة المحدثة للشاشات الكبيرة */}
//                   {item.dropdowns && (
//                     <div className="absolute left-1/2 -translate-x-1/2 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 z-50">
//                       <div className="bg-slate-900 border border-slate-800 shadow-2xl rounded-2xl p-6 flex gap-8 min-w-[580px]">
                        
//                         {/* عمود: قطاع الشركات والأعمال */}
//                         <div className="flex-1">
//                           <h4 className="text-amber-400 font-bold text-xs md:text-sm border-b border-slate-800 pb-2 mb-3 tracking-wide">
//                             {item.dropdowns.corporateAndInvestment.title}
//                           </h4>
//                           <div className="space-y-1">
//                             {item.dropdowns.corporateAndInvestment.links.map((subItem) => (
//                               <a
//                                 key={subItem.name}
//                                 href={subItem.path}
//                                 className="block px-3 py-2 text-xs md:text-sm text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors duration-200 border-r-2 border-transparent hover:border-amber-500"
//                               >
//                                 {subItem.name}
//                               </a>
//                             ))}
//                           </div>
//                         </div>

//                         {/* خط فاصل داخلي خفيف */}
//                         <div className="w-px bg-slate-800"></div>

//                         {/* عمود: الخدمات القضائية والوقائية */}
//                         <div className="flex-1">
//                           <h4 className="text-amber-400 font-bold text-xs md:text-sm border-b border-slate-800 pb-2 mb-3 tracking-wide">
//                             {item.dropdowns.litigationAndJudicial.title}
//                           </h4>
//                           <div className="space-y-1">
//                             {item.dropdowns.litigationAndJudicial.links.map((subItem) => (
//                               <a
//                                 key={subItem.name}
//                                 href={subItem.path}
//                                 className="block px-3 py-2 text-xs md:text-sm text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors duration-200 border-r-2 border-transparent hover:border-amber-500"
//                               >
//                                 {subItem.name}
//                               </a>
//                             ))}
//                           </div>
//                         </div>

//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ))}

//               {user && (
//                 <div className="flex items-center gap-4 border-r border-slate-300/50 pr-4 mr-2">
//                   <a href="/post" className={`text-sm font-medium hover:text-amber-600 transition ${isScrolled ? 'text-slate-700' : 'text-white'}`}>إنشاء منشور</a>
//                   <a href="/emails" className={`text-sm font-medium hover:text-amber-600 transition ${isScrolled ? 'text-slate-700' : 'text-white'}`}>البريد الإلكتروني</a>
//                   <LogoutButton />
//                 </div>
//               )}
//             </nav>

//             <button 
//               className="lg:hidden p-2 rounded-lg transition-colors duration-200 relative z-50 hover:bg-slate-100/10 focus:outline-none"
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               aria-label="Toggle Navigation"
//             >
//               {isMenuOpen ? 
//                 <X className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} /> : 
//                 <Menu className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} />}
//             </button>
//           </div>

//           {/* القائمة الجانبية المحدثة للهواتف لتتناسب مع القوائم المتداخلة */}
//           {isMenuOpen && (
//             <div className="lg:hidden fixed inset-x-4 top-20 bg-slate-900 border border-slate-800 rounded-2xl shadow-2xl p-4 z-40 max-h-[calc(100vh-120px)] overflow-y-auto duration-200">
//               <nav className="flex flex-col space-y-1">
//                 {navItems.map((item) => (
//                   <div key={item.name} className="border-b border-slate-800/60 last:border-0 pb-1 last:pb-0">
//                     <button
//                       onClick={(e) => {
//                         if (item.dropdowns) {
//                           setOpenMobileDropdown(openMobileDropdown === item.name ? null : item.name);
//                         } else if (item.href?.startsWith('#') && location.pathname === '/') {
//                           e.preventDefault();
//                           scrollToSection(item.href);
//                         } else {
//                           window.location.href = item.path || `/${item.href}`;
//                         }
//                       }}
//                       className="w-full text-right text-slate-200 hover:text-white text-base font-medium flex items-center justify-between py-3 px-4 hover:bg-slate-800 rounded-xl transition-colors duration-200"
//                     >
//                       <span>{item.name}</span>
//                       {item.dropdowns && (
//                         <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${openMobileDropdown === item.name ? 'rotate-180 text-amber-500' : 'text-slate-400'}`} />
//                       )}
//                     </button>

//                     {/* رندرة القوائم المتداخلة داخل شاشة الموبايل بشكل منسدل هرمي نظيف */}
//                     {item.dropdowns && openMobileDropdown === item.name && (
//                       <div className="mr-3 my-1 flex flex-col gap-3 border-r-2 border-slate-800 pr-3 py-2">
                        
//                         {/* فرع شاشة الموبايل الأول */}
//                         <div>
//                           <button 
//                             onClick={() => setOpenMobileSubSection(openMobileSubSection === 'corp' ? null : 'corp')}
//                             className="w-full text-right text-amber-400 font-bold text-sm py-1.5 flex items-center justify-between"
//                           >
//                             <span>{item.dropdowns.corporateAndInvestment.title}</span>
//                             <ChevronDown className={`w-3.5 h-3.5 transition-transform ${openMobileSubSection === 'corp' ? 'rotate-180' : ''}`} />
//                           </button>
//                           {openMobileSubSection === 'corp' && (
//                             <div className="mr-2 mt-1 flex flex-col bg-slate-950/40 rounded-lg py-1">
//                               {item.dropdowns.corporateAndInvestment.links.map((subItem) => (
//                                 <a key={subItem.name} href={subItem.path} className="text-xs text-slate-400 hover:text-white py-2 px-4">
//                                   {subItem.name}
//                                 </a>
//                               ))}
//                             </div>
//                           )}
//                         </div>

//                         {/* فرع شاشة الموبايل الثاني */}
//                         <div>
//                           <button 
//                             onClick={() => setOpenMobileSubSection(openMobileSubSection === 'lit' ? null : 'lit')}
//                             className="w-full text-right text-amber-400 font-bold text-sm py-1.5 flex items-center justify-between"
//                           >
//                             <span>{item.dropdowns.litigationAndJudicial.title}</span>
//                             <ChevronDown className={`w-3.5 h-3.5 transition-transform ${openMobileSubSection === 'lit' ? 'rotate-180' : ''}`} />
//                           </button>
//                           {openMobileSubSection === 'lit' && (
//                             <div className="mr-2 mt-1 flex flex-col bg-slate-950/40 rounded-lg py-1">
//                               {item.dropdowns.litigationAndJudicial.links.map((subItem) => (
//                                 <a key={subItem.name} href={subItem.path} className="text-xs text-slate-400 hover:text-white py-2 px-4">
//                                   {subItem.name}
//                                 </a>
//                               ))}
//                             </div>
//                           )}
//                         </div>

//                       </div>
//                     )}
//                   </div>
//                 ))}

//                 {user && (
//                   <div className="pt-4 mt-2 border-t border-slate-800 space-y-1">
//                     <a href="/post" className="text-slate-200 text-base font-medium block py-3 px-4 hover:bg-slate-800 rounded-xl transition">إنشاء منشور</a>
//                     <a href="/emails" className="text-slate-200 text-base font-medium block py-3 px-4 hover:bg-slate-800 rounded-xl transition">البريد الإلكتروني</a>
//                     <div className="pt-2 px-4"><LogoutButton /></div>
//                   </div>
//                 )}
//               </nav>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// };


// import React, { useState, useEffect } from 'react';
// import { supabase } from '../supabaseClient';
// import { 
//   Menu, 
//   X, 
//   ChevronDown, 
//   Phone, 
//   MapPin, 
//   Clock, 
//   Twitter, 
//   Instagram, 
//   Youtube, 
//   Linkedin 
// } from 'lucide-react';
// import { NRLogo } from './NRLogo';
// import { UserAuth } from './AuthContext';
// import LogoutButton from './LogOut';
// import { useNavigate, useLocation } from 'react-router-dom';

// export const Header = () => {
//   const location = useLocation(); 
//   const { session } = UserAuth();
//   const navigate = useNavigate();

//   const [user, setUser] = useState(null);
//   const [isMenuOpen, setIsMenuOpen] = useState(false);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
//   const [openMobileSubSection, setOpenMobileSubSection] = useState(null);

//   useEffect(() => {
//     const checkUser = async () => {
//       const currentSession = await session;
//       setUser(currentSession?.user || null);
//     };
//     checkUser();

//     const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
//       if (event === 'SIGNED_OUT') {
//         setUser(null);
//         navigate('/login');
//       } else if (event === 'SIGNED_IN') {
//         setUser(session?.user);
//       }
//     });

//     return () => {
//       listener.subscription.unsubscribe();
//     };
//   }, [session, navigate]);

//   useEffect(() => {
//     const handleScroll = () => {
//       setIsScrolled(window.scrollY > 40);
//     };
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navItems = [
//     { name: 'الرئيسية', href: '#hero' },
//     {
//       name: 'خدماتنا',
//       href: '#services',
//       dropdowns: {
//         corporateAndInvestment: {
//           title: 'قطاع الشركات والأعمال',
//           links: [
//             { name: 'الاستشارات القانونية', path: '/legal' },
//             { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
//             { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
//             { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
//             { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
//             { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
//             { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
//             { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
//             { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
//             { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
//           ]
//         },
//         litigationAndJudicial: {
//           title: 'الخدمات القضائية والوقائية',
//           links: [
//             { name: 'الترافع والتقاضي', path: '/litigation' },
//             { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
//             { name: 'الحراسة القضائية', path: '/judicial-custody' },
//             { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
//             { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
//             { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
//             { name: 'الأوقاف والوصايا', path: '/waqf-will' },
//             { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
//             { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
//             { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
//           ]
//         }
//       }
//     },
//     { name: 'عن الشركة', href: '#about' },
//     { name: 'فريق العمل', href: '#attorneys' },
//     { name: 'شركاؤنا', href: '#partners', path: '/partners' },
//     { name: 'اتصل بنا', href: '#contact' },
//   ];

//   const scrollToSection = (sectionId) => {
//     const section = document.querySelector(sectionId);
//     if (section) {
//       const headerHeight = document.querySelector('header').offsetHeight;
//       const sectionTop = section.offsetTop - headerHeight;
//       window.scrollTo({ top: sectionTop, behavior: 'smooth' });
//       setIsMenuOpen(false);
//     }
//   };

//   return (
//     <header className="fixed top-0 right-0 left-0 z-50 w-full" dir="rtl">
//       {/* 1. Dynamic TopBar */}
//       {/* <div 
//         className={`w-full bg-slate-900 text-slate-300 border-b border-amber-500/10 transition-all duration-300 hidden md:block overflow-hidden ${
//           isScrolled ? 'max-h-0 opacity-0 py-0 border-none' : 'max-h-12 py-2.5 opacity-100'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
//           <div className="flex items-center gap-6">
//             <div className="flex items-center gap-2 text-slate-400 text-xs lg:text-sm">
//               <Clock className="h-3.5 w-3.5 text-amber-500/80" />
//               <span>الأحد - الخميس | 8:00 ص - 5:00 م</span>
//             </div>
//             <div className="flex items-center gap-2 border-r border-slate-700/60 pr-6 text-xs lg:text-sm">
//               <Phone className="h-3.5 w-3.5 text-amber-500/80" />
//               <a href="tel:+966595014100" className="hover:text-amber-400 transition-colors duration-200 font-medium tracking-wide" dir="ltr">
//                 +966 59 501 4100
//               </a>
//             </div>
//           </div>

//           <div className="flex items-center gap-2 text-slate-400 text-xs lg:text-sm">
//             <MapPin className="h-3.5 w-3.5 text-amber-500/80" />
//             <span>جدة - المملكة العربية السعودية</span>
//           </div>

//           <div className="flex items-center gap-4">
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Twitter className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Instagram className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Youtube className="h-4 w-4" /></a>
//             <a href="#" className="p-1 hover:text-amber-400 transition-colors duration-200"><Linkedin className="h-4 w-4" /></a>
//           </div>
//         </div>
//       </div> */}

//       {/* 2. Main Navigation Bar */}
//       <div 
//         className={`w-full border-b transition-all duration-500 ${
//           isScrolled 
//             ? 'bg-white/95 backdrop-blur-sm shadow-md border-amber-500/20 py-2.5' 
//             : 'bg-transparent border-transparent py-5'
//         }`}
//       >
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <div className="flex items-center justify-between gap-4">
            
//             <div className="flex items-center gap-3 md:gap-4 shrink-0 z-50">
//               <NRLogo className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 transition-transform duration-300" color={isScrolled ? '#0f172a' : '#FFFFFF'} />
//               <div className="flex flex-col">
//                 <span className={`font-bold transition-colors duration-300 leading-tight text-xs sm:text-sm md:text-base lg:text-lg ${
//                   isScrolled ? 'text-slate-900' : 'text-white'
//                 }`}>
//                   شركة ناصر الراجحي ورامي المطيري
//                 </span>
//                 <span className={`font-medium text-[10px] sm:text-xs tracking-wide transition-colors duration-300 mt-0.5 ${
//                   //CHANGE COLOR FROM AMBER TO WHITE 
//                   isScrolled ? 'text-black' : 'text-white'
//                 }`}>
//                   للمحاماة والاستشارات القانونية
//                 </span>
//               </div>
//             </div>

//             {/* روابط التصفح للشاشات الكبيرة */}
//             <nav className="hidden lg:flex items-center gap-6 xl:gap-8 whitespace-nowrap">
//               {navItems.map((item) => (
//                 <div key={item.name} className="relative group py-2">
//                   <a 
//                     href={item.path ? item.path : (location.pathname === '/' ? item.href : `/${item.href}`)}
//                     onClick={(e) => {
//                       if (item.href && item.href.startsWith('#') && location.pathname === '/') {
//                         e.preventDefault();
//                         scrollToSection(item.href);
//                       }
//                     }}
//                     className={`text-sm xl:text-base font-medium transition-colors duration-300 flex items-center gap-1 hover:text-amber-600 ${
//                       isScrolled ? 'text-slate-700' : 'text-white/90'
//                     }`}
//                   >
//                     {item.name}
//                     {item.dropdowns && <ChevronDown className="w-3.5 h-3.5 opacity-70 group-hover:rotate-180 transition-transform duration-300" />}
//                   </a>

//                   {/* رندرة القائمتين المتداخلتين الفخمة المحدثة للشاشات الكبيرة */}
//                   {item.dropdowns && (
//                     <div className="absolute left-1/2 -translate-x-1/2 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 z-50">
//                       <div className="bg-slate-900 border border-slate-800 shadow-2xl rounded-2xl p-6 flex gap-8 min-w-[580px]">
                        
//                         {/* عمود: قطاع الشركات والأعمال */}
//                         <div className="flex-1">
//                           <h4 className="text-amber-400 font-bold text-xs md:text-sm border-b border-slate-800 pb-2 mb-3 tracking-wide">
//                             {item.dropdowns.corporateAndInvestment.title}
//                           </h4>
//                           <div className="space-y-1">
//                             {item.dropdowns.corporateAndInvestment.links.map((subItem) => (
//                               <a
//                                 key={subItem.name}
//                                 href={subItem.path}
//                                 className="block px-3 py-2 text-xs md:text-sm text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors duration-200 border-r-2 border-transparent hover:border-amber-500"
//                               >
//                                 {subItem.name}
//                               </a>
//                             ))}
//                           </div>
//                         </div>

//                         {/* خط فاصل داخلي خفيف */}
//                         <div className="w-px bg-slate-800"></div>

//                         {/* عمود: الخدمات القضائية والوقائية */}
//                         <div className="flex-1">
//                           <h4 className="text-amber-400 font-bold text-xs md:text-sm border-b border-slate-800 pb-2 mb-3 tracking-wide">
//                             {item.dropdowns.litigationAndJudicial.title}
//                           </h4>
//                           <div className="space-y-1">
//                             {item.dropdowns.litigationAndJudicial.links.map((subItem) => (
//                               <a
//                                 key={subItem.name}
//                                 href={subItem.path}
//                                 className="block px-3 py-2 text-xs md:text-sm text-slate-300 hover:text-white hover:bg-slate-800/50 rounded-lg transition-colors duration-200 border-r-2 border-transparent hover:border-amber-500"
//                               >
//                                 {subItem.name}
//                               </a>
//                             ))}
//                           </div>
//                         </div>

//                       </div>
//                     </div>
//                   )}
//                 </div>
//               ))}

//               {user && (
//                 <div className="flex items-center gap-4 border-r border-slate-300/50 pr-4 mr-2">
//                   <a href="/post" className={`text-sm font-medium hover:text-amber-600 transition ${isScrolled ? 'text-slate-700' : 'text-white'}`}>إنشاء منشور</a>
//                   <a href="/emails" className={`text-sm font-medium hover:text-amber-600 transition ${isScrolled ? 'text-slate-700' : 'text-white'}`}>البريد الإلكتروني</a>
//                   <LogoutButton />
//                 </div>
//               )}
//             </nav>

//             <button 
//               className="lg:hidden p-2 rounded-lg transition-colors duration-200 relative z-50 hover:bg-slate-100/10 focus:outline-none"
//               onClick={() => setIsMenuOpen(!isMenuOpen)}
//               aria-label="Toggle Navigation"
//             >
//               {isMenuOpen ? 
//                 <X className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} /> : 
//                 <Menu className={`h-6 w-6 ${isScrolled ? 'text-slate-900' : 'text-white'}`} />}
//             </button>
//           </div>

//           {/* القائمة الجانبية المحدثة للهواتف لتتناسب مع القوائم المتداخلة */}
//           {isMenuOpen && (
//             <div className="lg:hidden fixed inset-x-4 top-20 bg-slate-900 border border-slate-800 rounded-2xl shadow-2xl p-4 z-40 max-h-[calc(100vh-120px)] overflow-y-auto duration-200">
//               <nav className="flex flex-col space-y-1">
//                 {navItems.map((item) => (
//                   <div key={item.name} className="border-b border-slate-800/60 last:border-0 pb-1 last:pb-0">
//                     <button
//                       onClick={(e) => {
//                         if (item.dropdowns) {
//                           setOpenMobileDropdown(openMobileDropdown === item.name ? null : item.name);
//                         } else if (item.href?.startsWith('#') && location.pathname === '/') {
//                           e.preventDefault();
//                           scrollToSection(item.href);
//                         } else {
//                           window.location.href = item.path || `/${item.href}`;
//                         }
//                       }}
//                       className="w-full text-right text-slate-200 hover:text-white text-base font-medium flex items-center justify-between py-3 px-4 hover:bg-slate-800 rounded-xl transition-colors duration-200"
//                     >
//                       <span>{item.name}</span>
//                       {item.dropdowns && (
//                         <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${openMobileDropdown === item.name ? 'rotate-180 text-amber-500' : 'text-slate-400'}`} />
//                       )}
//                     </button>

//                     {/* رندرة القوائم المتداخلة داخل شاشة الموبايل بشكل منسدل هرمي نظيف */}
//                     {item.dropdowns && openMobileDropdown === item.name && (
//                       <div className="mr-3 my-1 flex flex-col gap-3 border-r-2 border-slate-800 pr-3 py-2">
                        
//                         {/* فرع شاشة الموبايل الأول */}
//                         <div>
//                           <button 
//                             onClick={() => setOpenMobileSubSection(openMobileSubSection === 'corp' ? null : 'corp')}
//                             className="w-full text-right text-amber-400 font-bold text-sm py-1.5 flex items-center justify-between"
//                           >
//                             <span>{item.dropdowns.corporateAndInvestment.title}</span>
//                             <ChevronDown className={`w-3.5 h-3.5 transition-transform ${openMobileSubSection === 'corp' ? 'rotate-180' : ''}`} />
//                           </button>
//                           {openMobileSubSection === 'corp' && (
//                             <div className="mr-2 mt-1 flex flex-col bg-slate-950/40 rounded-lg py-1">
//                               {item.dropdowns.corporateAndInvestment.links.map((subItem) => (
//                                 <a key={subItem.name} href={subItem.path} className="text-xs text-slate-400 hover:text-white py-2 px-4">
//                                   {subItem.name}
//                                 </a>
//                               ))}
//                             </div>
//                           )}
//                         </div>

//                         {/* فرع شاشة الموبايل الثاني */}
//                         <div>
//                           <button 
//                             onClick={() => setOpenMobileSubSection(openMobileSubSection === 'lit' ? null : 'lit')}
//                             className="w-full text-right text-amber-400 font-bold text-sm py-1.5 flex items-center justify-between"
//                           >
//                             <span>{item.dropdowns.litigationAndJudicial.title}</span>
//                             <ChevronDown className={`w-3.5 h-3.5 transition-transform ${openMobileSubSection === 'lit' ? 'rotate-180' : ''}`} />
//                           </button>
//                           {openMobileSubSection === 'lit' && (
//                             <div className="mr-2 mt-1 flex flex-col bg-slate-950/40 rounded-lg py-1">
//                               {item.dropdowns.litigationAndJudicial.links.map((subItem) => (
//                                 <a key={subItem.name} href={subItem.path} className="text-xs text-slate-400 hover:text-white py-2 px-4">
//                                   {subItem.name}
//                                 </a>
//                               ))}
//                             </div>
//                           )}
//                         </div>

//                       </div>
//                     )}
//                   </div>
//                 ))}

//                 {user && (
//                   <div className="pt-4 mt-2 border-t border-slate-800 space-y-1">
//                     <a href="/post" className="text-slate-200 text-base font-medium block py-3 px-4 hover:bg-slate-800 rounded-xl transition">إنشاء منشور</a>
//                     <a href="/emails" className="text-slate-200 text-base font-medium block py-3 px-4 hover:bg-slate-800 rounded-xl transition">البريد الإلكتروني</a>
//                     <div className="pt-2 px-4"><LogoutButton /></div>
//                   </div>
//                 )}
//               </nav>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// };



import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { 
  Menu, 
  X, 
  ChevronDown, 
  Phone, 
  MapPin, 
  Clock, 
  Twitter, 
  Instagram, 
  Youtube, 
  Linkedin 
} from 'lucide-react';
import { NRLogo } from './NRLogo';
import { UserAuth } from './AuthContext';
import LogoutButton from './LogOut';
import { useNavigate, useLocation } from 'react-router-dom';

export const Header = () => {
  const location = useLocation(); 
  const { session } = UserAuth();
  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const [openMobileSubSection, setOpenMobileSubSection] = useState(null);

  useEffect(() => {
    const checkUser = async () => {
      const currentSession = await session;
      setUser(currentSession?.user || null);
    };
    checkUser();

    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === 'SIGNED_OUT') {
        setUser(null);
        navigate('/login');
      } else if (event === 'SIGNED_IN') {
        setUser(session?.user);
      }
    });

    return () => {
      listener.subscription.unsubscribe();
    };
  }, [session, navigate]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'الرئيسية', href: '#hero' },
    {
      name: 'خدماتنا',
      href: '#services',
      dropdowns: {
        corporateAndInvestment: {
          title: 'قطاع الشركات والأعمال',
          links: [
            { name: 'الاستشارات القانونية', path: '/legal' },
            { name: 'الخدمات التعاقدية وصياغة العقود', path: '/contract' },
            { name: 'الامتثال والحوكمة', path: '/compliance-governance' },
            { name: 'الاستثمار الأجنبي', path: '/foreign-investment' },
            { name: 'الشركات الناشئة والمبتدئة', path: '/startups' },
            { name: 'لوائح وأنظمة العمل', path: '/work-regulations' },
            { name: 'الامتياز التجاري (الفرنشايز)', path: '/franchise' },
            { name: 'الملكية الفكرية وبراءات الاختراع', path: '/intellectual-property' },
            { name: 'الأمن السيبراني والتجارة الإلكترونية', path: '/cyber-e-commerce' },
            { name: 'إجراءات ومنازعات الإفلاس', path: '/bankruptcy-proceedings' }
          ]
        },
        litigationAndJudicial: {
          title: 'الخدمات القضائية والوقائية',
          links: [
            { name: 'الترافع والتقاضي', path: '/litigation' },
            { name: 'التحكيم وفض النزاعات', path: '/arbitration' },
            { name: 'الحراسة القضائية', path: '/judicial-custody' },
            { name: 'قضايا ومنازعات التنفيذ', path: '/execution' },
            { name: 'تحصيل الديون والالتزامات المالية', path: '/debt-collection' },
            { name: 'تصفية التركات والنزاعات الإرثية', path: '/estate-liquidation' },
            { name: 'الأوقاف والوصايا', path: '/waqf-will' },
            { name: 'التسجيل العقاري ومنازعات الملكية', path: '/real-estate-registration' },
            { name: 'خدمات التوثيق والوكالات', path: '/documentation' },
            { name: 'الدراسات والبحوث القانونية والأنظمة', path: '/legal-research-regulations' }
          ]
        }
      }
    },
    { name: 'عن الشركة', href: '#about' },
    { name: 'فريق العمل', href: '#attorneys' },
    { name: 'شركاؤنا', href: '#partners', path: '/partners' },
    { name: 'اتصل بنا', href: '#contact' },
  ];

  const scrollToSection = (sectionId) => {
    const section = document.querySelector(sectionId);
    if (section) {
      const headerHeight = document.querySelector('header').offsetHeight;
      const sectionTop = section.offsetTop - headerHeight;
      window.scrollTo({ top: sectionTop, behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  return (
    <header className="fixed top-0 right-0 left-0 z-50 w-full" dir="rtl">
      {/* 1. الشريط العلوي النظيف والمتناسق بالكامل مع النمط الفاتح الفخم */}
      {/* <div 
        className={`w-full bg-slate-50 text-slate-600 border-b border-slate-200 transition-all duration-300 hidden md:block overflow-hidden ${
          isScrolled ? 'max-h-0 opacity-0 py-0 border-none' : 'max-h-12 py-2.5 opacity-100'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2 text-slate-500 text-xs lg:text-sm">
              <Clock className="h-3.5 w-3.5 text-indigo-950/70" />
              <span>الأحد - الخميس | 8:00 ص - 5:00 م</span>
            </div>
            <div className="flex items-center gap-2 border-r border-slate-200 pr-6 text-xs lg:text-sm">
              <Phone className="h-3.5 w-3.5 text-indigo-950/70" />
              <a href="tel:+966595014100" className="hover:text-indigo-950 transition-colors duration-200 font-medium tracking-wide" dir="ltr">
                +966 59 501 4100
              </a>
            </div>
          </div>

          <div className="flex items-center gap-2 text-slate-500 text-xs lg:text-sm">
            <MapPin className="h-3.5 w-3.5 text-indigo-950/70" />
            <span>جدة - المملكة العربية السعودية</span>
          </div>

          <div className="flex items-center gap-4 text-slate-400">
            <a href="#" className="p-1 hover:text-indigo-950 transition-colors duration-200"><Twitter className="h-4 w-4" /></a>
            <a href="#" className="p-1 hover:text-indigo-950 transition-colors duration-200"><Instagram className="h-4 w-4" /></a>
            <a href="#" className="p-1 hover:text-indigo-950 transition-colors duration-200"><Youtube className="h-4 w-4" /></a>
            <a href="#" className="p-1 hover:text-indigo-950 transition-colors duration-200"><Linkedin className="h-4 w-4" /></a>
          </div>
        </div>
      </div> */}

      {/* 2. شريط الملاحة الرئيسي المحدث ديناميكياً للـ Navy Light */}
      <div 
        className={`w-full border-b transition-all duration-500 ${
          isScrolled 
            ? 'bg-white/95 backdrop-blur-sm shadow-sm border-slate-100 py-2.5' 
            : 'bg-white border-transparent py-2.5'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-4">
            
            <div className="flex items-center gap-3 md:gap-4 shrink-0 z-50">
              {/* التمرير اللوني الذكي للشعار ليتوافق مع التحول من الهيرو الشفاف إلى الأبيض الممرر */}
              <NRLogo className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 transition-transform duration-300" color={isScrolled ? '#1e1b4b' : '#FFFFFF'} />
              <div className="flex flex-col">
                <span className={`font-bold transition-colors duration-300 leading-tight text-xs sm:text-sm md:text-base lg:text-lg ${
                  isScrolled ? 'text-indigo-950' : 'text-indigo-950'
                }`}>
                  شركة ناصر الراجحي ورامي المطيري
                </span>
                <span className={`font-medium text-[10px] sm:text-xs tracking-wide transition-colors duration-300 mt-0.5 ${
                  isScrolled ? 'text-slate-600' : 'text-indigo-950'
                }`}>
                  للمحاماة والاستشارات القانونية
                </span>
              </div>
            </div>

            {/* روابط التصفح للشاشات الكبيرة */}
            <nav className="hidden lg:flex items-center gap-6 xl:gap-8 whitespace-nowrap">
              {navItems.map((item) => (
                <div key={item.name} className="relative group py-2">
                  <a 
                    href={item.path ? item.path : (location.pathname === '/' ? item.href : `/${item.href}`)}
                    onClick={(e) => {
                      if (item.href && item.href.startsWith('#') && location.pathname === '/') {
                        e.preventDefault();
                        scrollToSection(item.href);
                      }
                    }}
                    className={`text-sm xl:text-base font-semibold transition-colors duration-300 flex items-center gap-1 hover:text-blue-700 ${
                      isScrolled ? 'text-slate-700' :'text-indigo-950'
                    }`}
                  >
                    {item.name}
                    {item.dropdowns && <ChevronDown className="w-3.5 h-3.5 opacity-70 group-hover:rotate-180 transition-transform duration-300" />}
                  </a>

                  {/* الـ Mega Dropdown المحدثة بنظام ألوان معزز وعصري فاتح */}
                  {item.dropdowns && (
                    <div className="absolute left-1/2 -translate-x-1/2 top-full pt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-2 group-hover:translate-y-0 z-50">
                      <div className="bg-white border border-slate-100 shadow-2xl rounded-2xl p-6 flex gap-8 min-w-[580px]">
                        
                        {/* عمود: قطاع الشركات والأعمال */}
                        <div className="flex-1">
                          <h4 className="text-indigo-950 font-bold text-xs md:text-sm border-b border-slate-100 pb-2 mb-3 tracking-wide">
                            {item.dropdowns.corporateAndInvestment.title}
                          </h4>
                          <div className="space-y-1">
                            {item.dropdowns.corporateAndInvestment.links.map((subItem) => (
                              <a
                                key={subItem.name}
                                href={subItem.path}
                                className="block px-3 py-2 text-xs md:text-sm text-slate-500 hover:text-indigo-950 hover:bg-slate-50 rounded-lg transition-colors duration-200 border-r-2 border-transparent hover:border-indigo-950"
                              >
                                {subItem.name}
                              </a>
                            ))}
                          </div>
                        </div>

                        {/* خط فاصل داخلي رقيق جداً */}
                        <div className="w-px bg-slate-100"></div>

                        {/* عمود: Services القضائية والوقائية */}
                        <div className="flex-1">
                          <h4 className="text-indigo-950 font-bold text-xs md:text-sm border-b border-slate-100 pb-2 mb-3 tracking-wide">
                            {item.dropdowns.litigationAndJudicial.title}
                          </h4>
                          <div className="space-y-1">
                            {item.dropdowns.litigationAndJudicial.links.map((subItem) => (
                              <a
                                key={subItem.name}
                                href={subItem.path}
                                className="block px-3 py-2 text-xs md:text-sm text-slate-500 hover:text-indigo-950 hover:bg-slate-50 rounded-lg transition-colors duration-200 border-r-2 border-transparent hover:border-indigo-950"
                              >
                                {subItem.name}
                              </a>
                            ))}
                          </div>
                        </div>

                      </div>
                    </div>
                  )}
                </div>
              ))}

              {user && (
                <div className="flex items-center gap-4 border-r border-slate-200 pr-4 mr-2">
                  <a href="/post" className={`text-sm font-semibold text-navy-950 transition ${isScrolled ? 'text-slate-700' : 'text-navy-900'}`}>إنشاء منشور</a>
                  <a href="/emails" className={`text-sm font-semibold hover:text-blue-700 transition ${isScrolled ? 'text-slate-700' : 'text-navy-950'}`}>البريد الإلكتروني</a>
                  <LogoutButton />
                </div>
              )}
            </nav>

            <button 
              className="lg:hidden p-2 rounded-lg transition-colors duration-200 relative z-50 hover:bg-slate-100/10 focus:outline-none"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle Navigation"
            >
              {isMenuOpen ? 
                <X className={`h-6 w-6 ${isScrolled ? 'text-indigo-950' : 'text-indigo-950'}`} /> : 
                <Menu className={`h-6 w-6 ${isScrolled ? 'text-indigo-950' : 'text-indigo-950'}`} />}
            </button>
          </div>

          {/* القائمة الجانبية للموبايل بنمط Navy Light ناصع */}
          {isMenuOpen && (
            <div className="lg:hidden fixed inset-x-4 top-20 bg-white border border-slate-100 rounded-2xl shadow-2xl p-4 z-40 max-h-[calc(100vh-120px)] overflow-y-auto duration-200">
              <nav className="flex flex-col space-y-1">
                {navItems.map((item) => (
                  <div key={item.name} className="border-b border-slate-50 last:border-0 pb-1 last:pb-0">
                    <button
                      onClick={(e) => {
                        if (item.dropdowns) {
                          setOpenMobileDropdown(openMobileDropdown === item.name ? null : item.name);
                        } else if (item.href?.startsWith('#') && location.pathname === '/') {
                          e.preventDefault();
                          scrollToSection(item.href);
                        } else {
                          window.location.href = item.path || `/${item.href}`;
                        }
                      }}
                      className="w-full text-right text-slate-700 hover:text-indigo-950 text-base font-semibold flex items-center justify-between py-3 px-4 hover:bg-slate-50 rounded-xl transition-colors duration-200"
                    >
                      <span>{item.name}</span>
                      {item.dropdowns && (
                        <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${openMobileDropdown === item.name ? 'rotate-180 text-indigo-950' : 'text-slate-400'}`} />
                      )}
                    </button>

                    {/* القوائم المنسدلة الفرعية للموبايل الفاتحة والمنظمة */}
                    {item.dropdowns && openMobileDropdown === item.name && (
                      <div className="mr-3 my-1 flex flex-col gap-3 border-r-2 border-slate-100 pr-3 py-2">
                        
                        {/* فرع شاشة الموبايل الأول */}
                        <div>
                          <button 
                            onClick={() => setOpenMobileSubSection(openMobileSubSection === 'corp' ? null : 'corp')}
                            className="w-full text-right text-indigo-950 font-bold text-sm py-1.5 flex items-center justify-between"
                          >
                            <span>{item.dropdowns.corporateAndInvestment.title}</span>
                            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${openMobileSubSection === 'corp' ? 'rotate-180' : ''}`} />
                          </button>
                          {openMobileSubSection === 'corp' && (
                            <div className="mr-2 mt-1 flex flex-col bg-slate-50 rounded-lg py-1">
                              {item.dropdowns.corporateAndInvestment.links.map((subItem) => (
                                <a key={subItem.name} href={subItem.path} className="text-xs text-slate-500 hover:text-indigo-950 py-2 px-4">
                                  {subItem.name}
                                </a>
                              ))}
                            </div>
                          )}
                        </div>

                        {/* فرع شاشة الموبايل الثاني */}
                        <div>
                          <button 
                            onClick={() => setOpenMobileSubSection(openMobileSubSection === 'lit' ? null : 'lit')}
                            className="w-full text-right text-indigo-950 font-bold text-sm py-1.5 flex items-center justify-between"
                          >
                            <span>{item.dropdowns.litigationAndJudicial.title}</span>
                            <ChevronDown className={`w-3.5 h-3.5 transition-transform ${openMobileSubSection === 'lit' ? 'rotate-180' : ''}`} />
                          </button>
                          {openMobileSubSection === 'lit' && (
                            <div className="mr-2 mt-1 flex flex-col bg-slate-50 rounded-lg py-1">
                              {item.dropdowns.litigationAndJudicial.links.map((subItem) => (
                                <a key={subItem.name} href={subItem.path} className="text-xs text-slate-500 hover:text-indigo-950 py-2 px-4">
                                  {subItem.name}
                                </a>
                              ))}
                            </div>
                          )}
                        </div>

                      </div>
                    )}
                  </div>
                ))}

                {user && (
                  <div className="pt-4 mt-2 border-t border-slate-100 space-y-1">
                    <a href="/post" className="text-slate-700 text-base font-medium block py-3 px-4 hover:bg-slate-50 rounded-xl transition">إنشاء منشور</a>
                    <a href="/emails" className="text-slate-700 text-base font-medium block py-3 px-4 hover:bg-slate-50 rounded-xl transition">البريد الإلكتروني</a>
                    <div className="pt-2 px-4"><LogoutButton /></div>
                  </div>
                )}
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};